import { useQuery } from '@tanstack/react-query';

import { getUserDocumentRaw } from '@arrived/api_v2';
import { UserDocumentId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { userDocumentRawKeyFn } from './userDocuments.keys';

export function useUserDocumentRawQuery(userDocumentId: UserDocumentId, options?: UseQueryOptions<Blob>) {
  return useQuery(userDocumentRawKeyFn(userDocumentId), async () => getUserDocumentRaw(userDocumentId), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
